/**
 * Gérer l'intéractivité de la navigation rapide (quicknav) de la page d'accueil.
 *
 * @export
 * @class Quicknav
 */
export default class Quicknav {
    /**
     * Créer une instance de menu quicknav
     *
     * @memberof Quicknav
     */
    constructor() {
        //console.log("Dans constructor");
        // Mettre la main sur les liens qui ouvrent les sous-menus
        let liensSousMenus = document.querySelectorAll('.quicknav-aftermarket__lien-top--bleu-joyeux');
        // Assigner les listeners
        Array.from(liensSousMenus).forEach((lienSousMenu) => lienSousMenu.addEventListener('click', this.toggleSousMenu));
    }
    /**
     * Afficher - ou cacher - le sous-menu
     *
     * @public
     * @memberof Menu
     */
    //private toggleSousMenu(ev: Event): void
    toggleSousMenu() {
        //console.log("Dans toggleSousMenu");
        // Mettre la main sur l'id du sous-menu sur lequel l'utilisateur a cliqué
        let cible = this;
        // Mettre la main sur les liens qui ouvrent les sous-menus
        let liensSousMenus = document.querySelectorAll('.quicknav-aftermarket__lien-top--bleu-joyeux');
        // Boucler sur tous les sous-menu
        // Fermer le ou les sous-menus déjà ouverts (le cas échéant)
        // Toggle du sous-menu sur lequel l'utilisateur a cliqué
        Array.from(liensSousMenus).forEach((lienSousMenu) => {
            // Est-ce qu'on est rendu sur le sous-menu sur lequel l'utilisateur a cliqué
            if (cible.id == lienSousMenu.id) {
                // Toggle du sous-menu sur lequel l'utilisateur a cliqué
                // Mettre la main sur le sous-menu en question
                let leSousMenu = document.getElementById(cible.id + '-menu');
                // Mettre la main sur l'icone
                let icone = document.getElementById(cible.id + '-icone');
                // Vérifier le statut du menu
                if (leSousMenu.style.display == "flex") {
                    // Le menu est ouvert, il faut le fermer
                    leSousMenu.style.display = "";
                    // Il faut renverser l'icone
                    icone.style.transform = 'rotate(0)';
                }
                else {
                    // Le menu est fermé, il faut l'ouvrir
                    leSousMenu.style.display = 'flex';
                    // Il faut tourner l'icone
                    icone.style.transform = 'rotate(180deg)';
                }
            }
            else {
                let sousMenu = document.getElementById(lienSousMenu.id + '-menu');
                if (sousMenu.style.display == "flex") {
                    // Fermer le sous-menu déjà ouvert
                    sousMenu.style.display = "";
                    // Rotationner la flèche
                    let icone = document.getElementById(lienSousMenu.id + '-icone');
                    icone.style.transform = 'rotate(0)';
                }
            }
        });
    }
}
